import { Box, Text } from '@skin-seoul/design-system';

import { useProductCard } from '../ProductCardContext';
import { formatCurrency } from '@skin-seoul/service';

export const ProductCardInfoPrice = () => {
  const { currency, originalPrice, salePrice, theme = 'light' } = useProductCard();

  return (
    <Box display="flex" alignItems="center" gap="8px">
      {salePrice ? (
        <>
          <Text fontWeight="medium" textStyle="paragraph.large" color={theme === 'dark' ? 'neutral.50' : 'neutral.700'}>
            {formatCurrency(currency, salePrice)}
          </Text>
          <Text textStyle="paragraph.small" color="neutral.300" textDecoration="line-through">
            {formatCurrency(currency, originalPrice)}
          </Text>
        </>
      ) : (
        <Text fontWeight="medium" textStyle="paragraph.large" color={theme === 'dark' ? 'neutral.50' : 'neutral.700'}>
          {formatCurrency(currency, originalPrice)}
        </Text>
      )}
    </Box>
  );
};
